module.exports = __webpack_public_path__ + "static/img/28791.adc40d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/28791.jpg
// module id = qhnP
// module chunks = 1